<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Cliente">
      <b-container fluid class="mt-4">
        <b-alert v-model="showAlert" variant="danger" dismissible>
          {{ message }}
        </b-alert>
        <b-form>
          <div class="inputs-group px-3 py-3 mb-5">
            <h3 class="mb-4">Dados Gerais</h3>
            <b-row>
              <b-col>
                <b-form-group label="Nome / Razão Social" label-for="name">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="clientData.name"
                    :state="validateState('name')"
                    aria-describedby="input-1-live-feedback"
                    autocomplete="off"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    id="input-1-live-feedback"
                    style="font-weight: bold"
                  >
                    Campo obrigatório
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="CPF / CNPJ" label-for="cpf_CNPJ">
                  <b-form-input
                    id="cpf_CNPJ"
                    v-model="clientData.registerNumber"
                    autocomplete="off"
                    v-mask="cpfOrCnpjMask"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Nome Fantasia" label-for="fantasyName">
                  <b-form-input
                    id="fantasyName"
                    v-model="clientData.fantasyName"
                    autocomplete="off"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Telefone" label-for="phoneNumber">
                  <b-form-input
                    id="phoneNumber"
                    v-model="clientData.phoneNumber"
                    autocomplete="off"
                    v-mask="['(##) #####-####']"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Email" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="clientData.email"
                    autocomplete="off"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="inputs-group px-3 py-3 mb-5">
            <h3 class="mb-4">Endereço</h3>
            <b-row>
              <b-col>
                <b-form-group label="CEP" label-for="cep">
                  <b-form-input
                    id="cep"
                    v-model="clientData.cep"
                    autocomplete="off"
                    @blur="getAddressByCep"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Estado" label-for="state">
                  <b-form-input
                    v-model="state"
                    id="state"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Cidade" label-for="city">
                  <b-form-input
                    v-model="nameCity"
                    id="city"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="8">
                <b-form-group label="Rua" label-for="street">
                  <b-form-input
                    id="street"
                    v-model="clientData.street"
                    autocomplete="off"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Número" label-for="number">
                  <b-form-input
                    id="number"
                    v-model="clientData.houseAddressNumber"
                    autocomplete="off"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Bairro" label-for="neighborhood">
                  <b-form-input
                    id="neighborhood"
                    v-model="clientData.neighborhood"
                    autocomplete="off"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Complemento" label-for="complement">
                  <b-form-input
                    id="complement"
                    v-model="clientData.complement"
                    autocomplete="off"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div class="inputs-group px-3 py-3 mb-5">
            <b-row class="align-items-center">
              <b-col sm="2">
                <label for="color">Cor do contato:</label>
              </b-col>
              <b-col sm="4">
                <b-row class="align-items-center">
                  <b-col sm="4">
                    <b-form-input
                      type="color"
                      id="color"
                      v-model="clientData.city.color"
                      @input="updateOpacity"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <span>{{ clientData.city.color }}</span>
                  </b-col>
                  <b-col sm="4">
                    <span>{{ opacity + '%' }}</span>
                  </b-col>
                </b-row>
                <b-row class="align-items-center justify-content-center">
                  <span class="span-color">Cidade com cor pré-formatada</span>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-row class="justify-content-end px-3 py-3 mb-3">
            <b-col cols="auto">
              <b-row>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="danger"
                    @click="openModal(false)"
                  >
                    Cancelar
                  </b-button>
                </b-col>
                <b-col class="col-6">
                  <b-button
                    type="button"
                    variant="success"
                    @click="openModal(true)"
                  >
                    Salvar
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <ModalClient
        :isConfirm="isConfirm"
        @responseModalClient="responseModalClient($event)"
      />
      <ModalExit @responseModalLeaveView="confirmLeaveView()" />
    </Dashboard>
  </div>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import ModalClient from '../components/client/ModalClient.vue';
import ModalExit from '../components/client/ModalExit.vue';
import MixinModalClient from '../utils/MixinModalClient';
import { Cities, AddCity, EditCity } from '../services/City';
import { Client, EditClient } from '../services/Client';
import showError from '../utils/showError';

export default {
  components: { Dashboard, HeaderVue, Sidebar, ModalClient, ModalExit },
  mixins: [MixinModalClient, validationMixin],
  data() {
    return {
      clientData: {
        city: {},
      },
      cities: {},
      state: '',
      nameCity: '',
      showAlert: false,
      message: '',
      cpfOrCnpjValue: '',
    };
  },
  validations: {
    clientData: {
      name: {
        required,
      },
    },
  },

  computed: {
    cpfOrCnpjMask() {
      if (this.clientData && this.clientData.registerNumber) {
        if (this.clientData.registerNumber.length <= 14) {
          return ['###.###.###-##'];
        }
        return ['##.###.###/####-##'];
      }
      return '';
    },
  },
  created() {
    Client(this.$route.params.clientId)
      .then((res) => {
        this.clientData = res.data;
        this.updateOpacity();
        this.getAddressByCep();
      })
      .catch(showError);

    Cities()
      .then((res) => {
        this.cities = res.data;
      })
      .catch(showError);
  },
  methods: {
    validateState(field) {
      const { $dirty, $error } = this.$v.clientData[field];
      return $dirty ? !$error : null;
    },
    async getAddressByCep() {
      if (this.clientData.cep) {
        try {
          const response = await axios.get(
            `https://viacep.com.br/ws/${this.clientData.cep}/json/`
          );
          const { localidade, uf, cep } = response.data;
          this.clientData.cep = cep;
          this.state = uf;
          this.nameCity = localidade;
        } catch (error) {
          this.$toasted.global.defaultError();
        }
      }
    },
    async responseModalClient(event) {
      this.$v.clientData.$touch();
      if (this.$v.$anyError) {
        this.$bvModal.hide('modal-client');
        this.message = 'Verifique seus dados e tente novamente.';
        this.showAlert = true;
        return;
      }

      const data = {
        cityId: this.clientData.city.id,
        complement: this.clientData.complement,
        neighborhood: this.clientData.neighborhood,
        houseAddressNumber: this.clientData.houseAddressNumber,
        street: this.clientData.street,
        cep: this.clientData.cep,
        email: this.clientData.email,
        phoneNumber: this.clientData.phoneNumber,
        fantasyName: this.clientData.fantasyName,
        registerNumber: this.clientData.registerNumber,
        name: this.clientData.name,
      };
      if (event) {
        const nameCity = this.nameCity.toLowerCase();

        const existsCity = this.cities.some(
          (city) => city.name.toLowerCase() === nameCity
        );

        if (!existsCity) {
          await AddCity({ name: nameCity, color: this.clientData.city.color })
            .then((res) => {
              data.cityId = res.data.id;
            })
            .catch(showError);
        } else {
          data.cityId = this.cities.find(
            (city) => city.name.toLowerCase() === nameCity
          ).id;
        }

        await EditClient(this.clientData.id, data)
          .then(() => {
            EditCity(data.cityId, {
              name: nameCity,
              color: this.clientData.city.color,
            });
            this.$toasted.global.defaultSuccess();
          })
          .catch(showError);
      }
      this.leaveView = true;
      this.toBackClientView();
    },
  },
};
</script>

<style scoped>
form,
h3 {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #121212;
}
.inputs-group {
  background: rgba(217, 217, 217, 0.54);
  border-radius: 20px;
}

input,
input:focus,
[disabled] {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}
select#city.custom-select,
select#state.custom-select {
  border: 1px solid black;
  background-color: transparent;
  outline: none;
  box-shadow: none;
  color: black;
}

input[type='color'] {
  width: 35px;
  height: 35px;
  border: none;
}

input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 6px;
}

h3 {
  font-size: 25px;
  line-height: 30px;
}

span {
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
}

.span-color {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;

  color: rgba(0, 0, 0, 0.45);
}

label {
  font-size: 20px;
  line-height: 24px;
}

button {
  border: none;
  padding: 8px 40px 8px 40px;
  border-radius: 24px;
  color: white;
  font-weight: 400;
  font-size: 18px;
}
</style>
